export enum Collections {
    Users = 'Users',
    Sessions = 'Sessions',
    Questions = 'Questions',
    Runs = 'Runs',
    FollowUps = 'FollowUps',
    Tasks = 'Tasks',
    Feedback = 'Feedback',
    AiTips = 'AiTips',
    JobAnalysis = 'JobAnalysis'
}